const ATTR = 'data-puppy-auction-catalogue-download'
const STORAGE_PREFIX = 'puppyAuctionCatalogueDownloaded:'

const trigger = () => {
  const el = document.querySelector(`[${ATTR}]`)
  if (!el) return

  const url = el.getAttribute(ATTR)
  if (!url) return

  let storageKey
  try {
    storageKey = STORAGE_PREFIX + url
    if (sessionStorage.getItem(storageKey) === '1') return
  } catch (_e) {}

  if (el.dataset.puppyAuctionCatalogueDownloadTriggered === 'true') return
  el.dataset.puppyAuctionCatalogueDownloadTriggered = 'true'

  const a = document.createElement('a')
  a.href = url
  a.rel = 'noopener'
  a.setAttribute('download', '')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)

  try { sessionStorage.setItem(storageKey, '1') } catch (_e) {}
}

document.addEventListener('turbolinks:load', trigger)
document.addEventListener('DOMContentLoaded', trigger)
